import StateInterface from "../state-interface";

export const search_sort_by: StateInterface["search_sort_by"] = {
	sort_by: "",
};
